import React from 'react';
import { CHECKOUT_URL } from '../data/content';
type CTAButtonProps = {
  children: React.ReactNode;
  subtext?: string;
  variant?: 'green' | 'navy';
  size?: 'md' | 'lg';
  className?: string;
};
export function CTAButton({
  children,
  subtext,
  variant = 'green',
  size = 'lg',
  className = ''
}: CTAButtonProps) {
  const palette = variant === 'green' ? 'bg-clinic-500 hover:bg-clinic-600 text-white shadow-[0_10px_0_0_#0a5c33] active:shadow-[0_4px_0_0_#0a5c33]' : 'bg-navy-800 hover:bg-navy-900 text-white shadow-[0_10px_0_0_#061225] active:shadow-[0_4px_0_0_#061225]';
  const sizing = size === 'lg' ? 'px-5 py-4 text-base sm:text-lg md:text-xl' : 'px-4 py-3 text-sm sm:text-base';
  return <div className={`w-full ${className}`} data-id="element-31" data-mp="2yql4iufrgcy2">
      <a href={CHECKOUT_URL} className={`group flex w-full items-center justify-center gap-2 rounded-xl text-center font-extrabold uppercase leading-tight tracking-tight transition-[transform,background-color,box-shadow] duration-150 ease-out hover:-translate-y-0.5 active:translate-y-1.5 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-clinic-600 ${palette} ${sizing}`} data-id="element-32" data-mp="3cpual1a95qob">
        <span className="text-balance" data-id="element-33" data-mp="1i8terqiuh971">{children}</span>
      </a>
      {subtext && <p className="mt-3 text-center text-[11px] font-semibold uppercase tracking-wide text-navy-500 sm:text-xs" data-id="element-34" data-mp="1n9pdlpoca55l">
          {subtext}
        </p>}
    </div>;
}